import { css } from 'lit';

export default css`
  :host([keyboard-open]) {
    --current-header-height: 6rem;
  }
  :host {
    --current-header-height: 18rem;
    width: 100vw;
    max-width: 100vw;
  }
  :host(.header-small) {
   // --current-header-height: 12rem;
  }
  
  ::slotted(lh-header[keyboard-open]) {
    --header-height: 6rem;
  }
  ::slotted(lh-header) {
    --header-height: var(--current-header-height);
    /*filter: unset;*/
    z-index: 1;
  }
  ::slotted(lh-questionnaire) {
    z-index: 0;
    height: calc(var(--maxH, 100vh) - var(--current-header-height));
    position: absolute;
    bottom: 0;
    width: 100%;
    overflow-y: auto;
  }
  ::slotted(lh-questionnaire[isNewLandingPage]) {
    height: auto;
    top: 0;
    bottom: unset;
  }
  :host(.header-high) ::slotted(lh-header) {
      --header-height: 6rem;
      --current-header-height: 6rem;
  }
  :host([keyboard-open]) ::slotted(lh-questionnaire) {
    height: calc(100% - var(--current-header-height));
  }
  :host(.section-changing) {
    --transition-speed: 150ms;
    --current-header-height: 38rem;
  }

  :host([display-mode="summary"]) {
    --current-header-height: 100%;
  }

  :host(.additional-insured-mta) {
    --current-header-height: 15rem;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: var(--maxH, 100vh);
    height: auto;
    min-height: var(--maxH, 100vh);
  }

  /* Pin the header above the fixed wave (path-top-header--ai-mta) AND fix it to
     the viewport top so logo + name + chat button stay anchored as the page
     scrolls (lighthouse's lh-header mobileStyles is empty — base is relative). */
  :host(.additional-insured-mta) ::slotted(lh-header) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 5;
  }

  :host(.additional-insured-mta) ::slotted(lh-additional-insured-mta-screen) {
    position: relative;
    z-index: 0;
    width: min(100%, 110rem);
    max-width: 110rem;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    min-height: calc(var(--maxH, 100vh) - 6rem);
    overflow-y: visible;
    padding-bottom: 4rem;
    box-sizing: border-box;
  }
`;